import React from 'react';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs.esm.js';
import 'tslib';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import '@panwds/icons';
import { Body } from '../Typography/Body.esm.js';
import '../Tooltip/Tooltip.esm.js';
import { Title } from '../Typography/Title.esm.js';

/**
 * Page header displays the top level page content, including:
 *
 * * Title
 * * Subtitle
 * * Actions
 * * Breadcrumbs
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Button, PageHeader } from "@panwds/react-ui";
 *
 * // Import breadcrumb links from your local Link component
 * // that is connected to your router.
 * import { Link } from 'react-router-dom';
 * ```
 */
function PageHeader(_a) {
    var actions = _a.actions, breadcrumbs = _a.breadcrumbs, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, icon = _a.icon, subtitle = _a.subtitle, _b = _a.subtitleSize, subtitleSize = _b === void 0 ? "sm" : _b, title = _a.title;
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "header-".concat(typeof title === "string" && testIdGen(title)), className: "tw-font-lato tw-flex tw-justify-between tw-items-center" },
        React.createElement("div", { className: "tw-flex tw-flex-col" },
            breadcrumbs && React.createElement(Breadcrumbs, null, breadcrumbs),
            React.createElement("div", { className: "tw-flex tw-items-center tw-space-x-1" },
                icon && React.createElement("div", null, icon),
                React.createElement(Title, { level: 1, size: "sm" }, title)),
            subtitle && (React.createElement(Body, { addClassName: "tw-mt-1", appearance: "secondary", size: subtitleSize }, subtitle))),
        actions && React.createElement("div", { className: "tw-flex tw-space-x-1" }, actions)));
}

export { PageHeader };
//# sourceMappingURL=PageHeader.esm.js.map
